import { configureStore } from "@reduxjs/toolkit";
import cookieConsentReducer from "./cookieConsentSlice";
import promoBannerReducer from "./promoBannerSlice";
import themeReducer from "./themeSlice";

export function makeStore() {
  return configureStore({
    reducer: {
      cookieConsent: cookieConsentReducer,
      promoBanner: promoBannerReducer,
      theme: themeReducer,
    },
  });
}

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
